/* eslint-disable no-unused-vars */
export enum RelationshipType {
  SPOUSE = 'Spouse',
  SON = 'Son',
  HUSBAND = 'Husband',
  NOT_APPLICABLE = 'N/A',
  DAUGHTER = 'Daughter',
  Family = 'Family',
  Parent = 'Parent',
  Sibling = 'Sibling',
  DOMESTIC_PARTNER = 'domestic_partner',
  EX_SPOUSE = 'ex_spouse',
  FAMILY_CONTACT = 'family_contact',
  OTHER_CONTACT = 'other_contact',
  CHILD = 'Child',
  DOMESTIC_PARTNER_LABEL = 'Domestic Partner',
  EX_SPOUSE_LABEL = 'Ex spouse',
  FAMILY_CONTACT_LABEL = 'Family Contact',
  OTHER_CONTACT_LABEL = 'Other Contact',
}

export enum MaritalStatus {
  SINGLE = 'Single',
  MARRIED = 'Married',
  DIVORCED = 'Divorced',
  NOT_APPLICABLE = 'N/A',
}

export enum Gender {
  FEMALE = 'Female',
  MALE = 'Male',
  NOT_APPLICABLE = 'N/A',
}

export interface IDependent {
  id?: string;
  firstName: string;
  middleName?: string;
  lastName: string;
  relationshipType?: string;
  relationship?: string;
  gender?: string;
  ssn?: string;
  birthDate?: string | Date;
  workPhone?: string;
  homePhone?: string;
  email?: string;
  isPersonalContact?: boolean;
  isEmergencyContact?: boolean;
  isBeneficiary?: boolean;
  isDependent?: boolean;
  address?: string;
  city?: string;
  state?: string;
  zipCode?: string;
  country?: string;
  county?: string;
  notes?: string;
  studentStatus?: boolean;
  smokerStatus?: boolean;
}
